import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DynamicFormModal, { ENTITY_CONFIGS } from '../../../formBuilder/wrappers/DynamicFormModal';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteLab } from '../../../../services/clinicPortalServices/labService';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

import RecordDetails from '../../../common/RecordDetails';
const panelStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 },
    panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' },
    header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' },
    title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' },
    body: { padding: '20px', flex: 1 },
    section: { marginBottom: '20px' },
    sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' },
    dl: { display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: '8px', margin: 0 },
    dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' },
    dd: { fontSize: '13px', color: '#222', margin: 0 },
    editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' },
    closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' }
};

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            labId: props.data._id
        };
    }

    handleDelete = () => {
        let warningText = 'You will not be able to recover this lab!';
        if (this.props.data.isDefault) {
            warningText = 'You are removing the default lab PDF information.  A default option is always required.  If you remove this as the default and do not select a new default one, the default bluelot template will show instead of your lab';
        }
        Swal.fire({
            title: 'Are you sure?',
            text: warningText,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container: window.localStorage.getItem('appTheme') === 'Dark' && /clinic|lims/.test(window.location.pathname.split('/')[1]) && 'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteLab({ _id: this.state.labId, name: this.props.data.name }).then(() => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
        const lab = this.props.data;
        if (lab) {
            trackRecentView('lab', lab._id, lab.name || 'Lab', '/clinic/lab');
        }
    };

    handleClose = () => this.setState({ show: false });

    renderPanel() {
        const d = this.props.data;
        const address = [d.address, d.city, d.state, d.zip].filter(Boolean).join(', ');
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>Lab Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}>
                                <i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit
                            </button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Lab Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Name</dt>
                                <dd style={panelStyles.dd}>{d.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Parent Company</dt>
                                <dd style={panelStyles.dd}>{d.parentCompany || '—'}</dd>
                                <dt style={panelStyles.dt}>Default</dt>
                                <dd style={panelStyles.dd}>{d.isDefault ? 'Yes' : 'No'}</dd>
                                <dt style={panelStyles.dt}>Director</dt>
                                <dd style={panelStyles.dd}>{d.directorName || '—'}</dd>
                                <dt style={panelStyles.dt}>Phone</dt>
                                <dd style={panelStyles.dd}>{d.phoneNumber || '—'}</dd>
                            </dl>
                        </div>
                        {address && (
                            <div style={panelStyles.section}>
                                <div style={panelStyles.sectionTitle}>Address</div>
                                <div style={{ fontSize: '13px', color: '#222' }}>{address}</div>
                            </div>
                        )}
                    
                        <RecordDetails data={d} exclude={['address', 'city', 'directorName', 'isDefault', 'name', 'parentCompany', 'phoneNumber', 'state', 'zip', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Lab</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Edit Lab</Tooltip>}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Delete Lab</Tooltip>}>
                    <button onClick={this.handleDelete} className="edit-order-btn">
                        <i className="fas fa-trash"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <ModalStyled size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.show} onHide={this.handleClose} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Update Lab Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DynamicFormModal entityType="lab" entityId={this.state.labId} entityConfig={ENTITY_CONFIGS.lab} context={this.props.context} handleClose={this.handleClose} />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
